


















import {Component, Prop, Vue} from "vue-property-decorator";
import TextField from "@/components/inputs/TextField.vue";
import Number from "@/components/inputs/Number.vue";
import EForm from "@/components/datatable/EForm.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
class requestPayload {
    selectedIds :number[] = [];
    piece:number = 1;
    enabled:boolean = false;
}
@Component({
    components: {EnabledSwitch, EForm, Number, TextField}
})
export default class CopyButton extends Vue {
    @Prop({required:true,default:[]}) selectedIds!:number[];
    @Prop({required:true}) action!:string;
    dialog = false;
    data : requestPayload = new requestPayload();
    copy(){
        if(this.selectedIds.length == 0){
            alert("Lütfen kopyalanacak satır seçiniz !");
            return;
        }
        this.dialog = true;
        this.data.selectedIds = this.selectedIds;
    }
    success(data:any){
        this.dialog = false;
        this.$emit("success",data);
    }

}
